/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Skeleton } from '@doveit/lego';
import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import * as styles from './ArticleCard.style';
import { URLObject } from '../../utils/links';

export const ArticleCardSkeleton: FunctionComponent = () => (
  <div css={styles.base}>
    <div css={styles.imageWrapper}>
      <Skeleton height="9.3rem" />
    </div>
    <div css={styles.info}>
      <div css={styles.title}>
        <Skeleton width="70%" />
      </div>
      <div css={styles.details}>
        <Skeleton width="40%" />
      </div>
      <div css={styles.abstract}>
        <Skeleton count={3} />
      </div>
    </div>
  </div>
);

export interface ArticleCardProps {
  title: string,
  abstract: string,
  dataRef?: string,
  onClick: (path: string) => void,
  urlObject: URLObject,
  date?: string,
  dateLabel?: string,
  imageURL: string,
  imageAlt: string,
}

const ArticleCard: FunctionComponent<ArticleCardProps> = ({
  title,
  abstract,
  dataRef,
  onClick,
  urlObject,
  date,
  dateLabel = 'Pubblicato il',
  imageURL,
  imageAlt,
}) => (
  <article
    data-ref={dataRef || 'article-card'}
    onClick={() => onClick(urlObject.as)}
    css={styles.base}
  >
    <div css={styles.imageWrapper}>
      {imageURL ? (
        <Image
          src={imageURL}
          width={340}
          height={224}
          alt={imageAlt}
        />
      ) : (
        <div css={styles.imagePlaceholder} />
      )}
    </div>
    <div css={styles.info}>
      <h4
        css={styles.title}
        data-ref={`${dataRef}-title`}
      >
        <Link
          href={urlObject.url}
          as={urlObject.as}
        >
          {title}
        </Link>
      </h4>
      <div css={styles.details}>
        {date && (
          <span data-ref="publish-date">
            {dateLabel}
            {' '}
            <strong>{date}</strong>
          </span>
        )}
      </div>
      <p css={styles.abstract}>
        {abstract}
      </p>
    </div>
  </article>
);

export default ArticleCard;
